import {
  enableBodyLock,
  disableBodyLock,
  disableLockModalSafari
} from '../helpers/body-lock';

import EmblaCarousel from 'embla-carousel'


export default () => {
  const selectors = {
    open: '[js-modal="open"]',
    close: '[js-modal="close"]',
    modal: '[js-modal="modal"]'
  };

  const nodeSelectors = {
    open: document.querySelectorAll(selectors.open),
    close: document.querySelectorAll(selectors.close),
    modal: document.querySelectorAll(selectors.modal),
  };

  function setEventListeners() {
    nodeSelectors.open.forEach(item => {
      item.addEventListener('click', function (evt) {
        closeModal();
        openModal(evt);
      })
    });

    nodeSelectors.close.forEach(item => {
      item.addEventListener('click', function (evt) {
        closeModal(evt);
      })
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') {
        closeModal(evt);
      }
    });
  }

  function openModal(evt) {
    enableBodyLock();
    const targetModal = evt.target.dataset.modalId;
    const modal = document.querySelector(`#${targetModal}`);
    modal.classList.add('is-active');

    setTimeout(() => {
      const toggleFiltersButton = modal.querySelector('.account-filters-toggle');
      const targetGrid = modal.querySelector('.featured-collection-list__grid');

    if (toggleFiltersButton && targetGrid) {
      if (!toggleFiltersButton.dataset.listenerAttached) {
        toggleFiltersButton.addEventListener('click', () => {
          targetGrid.classList.toggle('active');
          toggleFiltersButton.classList.toggle('active');
        });
  
        toggleFiltersButton.dataset.listenerAttached = 'true';
      }
    }



    },1000)
   

    setTimeout(() => {

      const emblaNode = document.querySelector('.embla.account-embla')
      const options = {
        loop: false,
        align: 'start',
        // slidesToScroll: 'auto',
        breakpoints: {
          "(max-width: 1300px)": {
            slidesToScroll: 3
          },
          "(max-width: 600px)": {
            slidesToScroll: 1.5
          },
        },
      }
      const emblaApi = EmblaCarousel(emblaNode, options)
    }, 1000)


  }

  function closeModal() {
    disableBodyLock();
    disableLockModalSafari();
    nodeSelectors.modal.forEach(item => {
      item.classList.remove('is-active');
    });
  }

  /**
   * Initialize the script
   */
  function init() {
    if (!nodeSelectors.open) {
      return
    }
    setEventListeners();
  }

  return Object.freeze({
    init,
  });
};
